module.exports = __webpack_public_path__ + "static/media/sun-glasses-1.abdaca38.jpg";